import { createContext } from 'react';

const PairAddressContext = createContext<string>('');
export default PairAddressContext;
